import React, { useEffect, useRef, useState } from 'react';
import { Button, Modal, Popconfirm, Table, Tag } from "antd";
import $ from "jquery";
import { toast } from "react-toastify";
import API_LINK from "../../../components/link/Link";
import { BiCheckDouble, BiTrash } from "react-icons/bi";
import * as XLSX from 'xlsx';

function Verifications() {
    const [accountDetails, setAccountDetails] = useState('');
    const [isAccountModalOpen, setIsAccountModalOpen] = useState(false);
    const [usersData, setUsersData] = useState([]);
    const [filterData, setFilterData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [message, setMessage] = useState('');
    const [currentData, setCurrentData] = useState({});
    const [open, setOpen] = useState(false);
    const tableRef = useRef(null);

    useEffect(() => {
        LoadData();
    }, []);

    const LoadData = async () => {
        try {
            setIsLoading(true);
            let formdata = new FormData();
            if (localStorage.getItem('Role') === "Admin") {
                formdata.append("page", "LoadUsers");
            } else {
                formdata.append("page", "LoadUserForVerification");
                formdata.append("userId", localStorage.getItem('UserId'));
            }

            const response = await fetch(`${API_LINK}Users.php`, {
                method: 'POST',
                body: formdata,
                redirect: 'follow'
            });

            const result = await response.json();
            if (result.status === 1) {
                setUsersData(result.data);
                setFilterData(result.data);
            } else {
                toast.error("Server Error! Please try again later.");
            }
            setIsLoading(false);
        } catch (e) {
            console.log(e);
        }
    };

    const handleSubmit = async (user, status) => {
        let toaster = toast.loading("Processing...");
        try {
            let formdata = new FormData();
            formdata.append("page", "UpdateUserStatus");
            formdata.append("userId", user.id);
            formdata.append("email", user.Email);
            formdata.append("status", status);
            formdata.append("message", message);

            const response = await fetch(`${API_LINK}Users.php`, {
                method: 'POST',
                body: formdata,
                redirect: 'follow'
            });
            const result = await response.json();

            if (result.status === 1) {
                setTimeout(() => {
                    toast.update(toaster, {
                        type: "success",
                        render: "User status has been changed successfully.",
                        isLoading: false,
                        autoClose: 3000,
                        closeOnClick: true,
                        closeButton: true
                    });
                    LoadData();
                }, 1000);
            } else {
                toast.update(toaster, {
                    type: "error",
                    render: "Server Error! Please try again later.",
                    isLoading: false,
                    autoClose: 3000,
                    closeOnClick: true,
                    closeButton: true
                });
            }
        } catch (e) {
            console.log(e);
        }
    };

    const handleAccountSubmit = async () => {
        if (!accountDetails.trim()) {
            toast.warning("Please enter account details first");
            return;
        }

        const toaster = toast.loading("Saving & Sending, please wait...");

        let formData = new FormData();
        formData.append("page", "UpdateAccountDetails");
        formData.append("userId", currentData.id);
        formData.append("email", currentData.Email);
        formData.append("account_details", accountDetails);

        try {
            const response = await fetch(`${API_LINK}Users.php`, {
                method: "POST",
                body: formData
            });
            const result = await response.json();

            if (result.status === 1) {
                toast.update(toaster, {
                    render: "Account details saved and emailed.",
                    type: "success",
                    isLoading: false,
                    autoClose: 3000,
                    closeOnClick: true,
                    closeButton: true
                });
                setIsAccountModalOpen(false);
                LoadData();
            } else {
                toast.update(toaster, {
                    render: "Failed to save account details.",
                    type: "error",
                    isLoading: false,
                    autoClose: 3000,
                    closeOnClick: true,
                    closeButton: true
                });
            }
        } catch (error) {
            console.error(error);
            toast.update(toaster, {
                render: "Something went wrong. Try again.",
                type: "error",
                isLoading: false,
                autoClose: 3000,
                closeOnClick: true,
                closeButton: true
            });
        }
    };

    const handleSearch = (event) => {
        const search = event.target.value.toLowerCase();
        if (search) {
            const filtered = filterData.filter(user =>
                user.FirstName.toLowerCase().includes(search) ||
                user.LastName.toLowerCase().includes(search) ||
                user.Email.toLowerCase().includes(search)
            );
            setUsersData(filtered);
        } else {
            setUsersData(filterData);
        }
    };

    const exportToExcel = () => {
        const modifiedData = usersData.map(({ IDCardFront, IDCardBack, IDCard, Password, ...rest }) => rest);
        const ws = XLSX.utils.json_to_sheet(modifiedData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Users Data');
        XLSX.writeFile(wb, 'users_data.xlsx');
    };

    return (
        <>
            {/* Reject Modal */}
            <Modal
                open={open}
                okText={'Reject Now'}
                onOk={async () => {
                    if (message) {
                        setOpen(false);
                        setMessage("");
                        await handleSubmit(currentData, "Rejected");
                    } else {
                        toast.warn("Please enter reason first");
                    }
                }}
                title={<p>Reason of Rejection</p>}
                onCancel={() => setOpen(false)}
            >
                <div className="model-form">
                    <div className="form-group">
                        <label>Reason/Message</label>
                        <textarea value={message} onChange={e => setMessage(e.target.value)}></textarea>
                    </div>
                </div>
            </Modal>

            {/* Account Details Modal */}
            <Modal
                title="Edit Account Details"
                open={isAccountModalOpen}
                onCancel={() => setIsAccountModalOpen(false)}
                onOk={handleAccountSubmit}
                okText="Save & Send Email"
            >
                <div className="form-group">
                    <label>Account Details</label>
                    <textarea
                        rows={5}
                        className="form-control"
                        value={accountDetails}
                        onChange={(e) => setAccountDetails(e.target.value)}
                    />
                </div>
            </Modal>

            <div className="dashboard-content-container">
                <div className="dashboard-content">
                    <div className="dashboard-content-title">
                        <h1>Verifications</h1>
                        <small>
                            Please submit the required documents in order to get your identity verified.
                            Unverified accounts do not get the signup bonus and cannot make any deposit or withdrawal.
                        </small>
                    </div>
                    <div className="dashboard-content-table">
                        <div className="table-export">
                            <input
                                type="search"
                                name="search"
                                id="search"
                                className="table-search-input"
                                placeholder="Search"
                                onChange={handleSearch}
                            />
                            <button className="btn btn-primary" onClick={exportToExcel}>
                                Export Excel
                            </button>
                        </div>
                        <Table dataSource={usersData} pagination={{ pageSize: 10 }} loading={isLoading} ref={tableRef}>

                            <Table.Column title="#" width={70} render={(text, record, index) => <span>{index + 1}</span>} />
                            <Table.Column title="First Name" dataIndex="FirstName" />
                            <Table.Column title="Last Name" dataIndex="LastName" />
                            <Table.Column title="Email" dataIndex="Email" />
                            <Table.Column title="Phone" dataIndex="Phone" />
                            <Table.Column title="Created At" dataIndex="Date" />
                            <Table.Column title="Status" render={(u) => {
                                const color = u.Status === "Approved" ? "green" :
                                    u.Status === "Rejected" ? "red" : "gray";
                                return <Tag color={color}>{u.Status.toUpperCase()}</Tag>
                            }} />

                            {
                                localStorage.getItem("Role") === "Admin" &&
                                <>
                                    <Table.Column title="Approve" render={(u) => (
                                        <Button type="primary" icon={<BiCheckDouble />} onClick={() => handleSubmit(u, "Approved")} />
                                    )} />
                                    <Table.Column title="Reject" render={(u) => (
                                        <Popconfirm
                                            title="Reject this user?"
                                            onConfirm={() => {
                                                setCurrentData(u);
                                                setOpen(true);
                                            }}
                                            okText="Yes"
                                            cancelText="No"
                                        >
                                            <Button danger icon={<BiTrash />} />
                                        </Popconfirm>
                                    )} />

                                    <Table.Column
                                        title="Account Details"
                                        render={(u) => (
                                            <Button
                                                type="default"
                                                onClick={() => {
                                                    setCurrentData(u);
                                                    setAccountDetails(u.AccountDetails || "");
                                                    setIsAccountModalOpen(true);
                                                }}
                                            >
                                               Edit & Send Accounts
                                            </Button>
                                        )}
                                    />
                                </>
                            }
                        </Table>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Verifications;
